import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksListOnlyRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-list-only',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/list',
	exact: true,
};
